import { Component, forwardRef, Input } from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { Util } from "../../controller/Util";

const FIELD_VALUE_ACESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => ToggleButtonComponent),
    multi: true,
};

@Component({
    selector: "app-toggle-button",
    templateUrl: "./toggle-button.component.html",
    styleUrl: "./toggle-button.component.scss",
    providers: [FIELD_VALUE_ACESSOR],
    standalone: false,
})

export class ToggleButtonComponent implements ControlValueAccessor {
    @Input() flex_direction: "flex-col" | "flex-row" = "flex-col";

    @Input() label: string = "";
    @Input() id: string = Util.randomId();
    @Input() isReadOnly = false;
    @Input() onLabel = "Sim";
    @Input() offLabel = "Não";
    @Input() styleClass = "max-w-[100px]";

    private innerValue: any;

    get value() {
        return this.innerValue;
    }

    set value(v: any) {
        if (v !== this.innerValue) {
            this.innerValue = v;
            this.onChange(v);
        }
    }

    constructor() {}

    onChange: (_: any) => void = () => {};
    onTouched: (_: any) => void = () => {};

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        this.isReadOnly = isDisabled;
    }

    writeValue(v: any): void {
        this.value = v;
    }

    changeValue($event: any) {
        this.value = $event.checked;
    }
}
